import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'

import * as atoms from 'src/v2/state/owner-reveal/parcel-layer'

export const useToggleParcelsLayer = () => {
  const [showParcels, setShowParcels] = useAtom(atoms.showParcelLayer)
  const [showParcelsCache] = useState(showParcels)

  useEffect(() => {
    if (showParcels) {
      setShowParcels(false)
    }

    return () => {
      setShowParcels(showParcelsCache)
    }
  }, [])
}
